var map = {
	"./aparthotelclub/ic_tag_size.png": 29215,
	"./beachful/ic_tag_size.png": 83746,
	"./castlepedia/ic_tag_size.png": 89035,
	"./cocktayl/ic_tag_size.png": 16921,
	"./ic_tag_size.png": 7717,
	"./luxresortclub/ic_tag_size.png": 88118,
	"./parkful/ic_tag_size.png": 47906,
	"./prefabworld/ic_tag_size.png": 14051,
	"./rooftopclub/ic_tag_size.png": 40785,
	"./spaclub/ic_tag_size.png": 684,
	"./worldcasino/ic_tag_size.png": 921,
	"./zoopedia/ic_tag_size.png": 99158
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89030;